export function initAccomodationSlider() {
	const el = document.querySelector(".accomodation-slider");
	if (!el) return;

	const slider = new Splide(el, {
		type: "fade",
		rewind: true,
		speed: 600,
		autoplay: false,
		arrows: true,
		pagination: false,
	});
	slider.mount();
}
